import {
  VIEW, TableAction,
} from '@/helpers/enums/table-actions'
import { dateFormatter } from '@/helpers/dateFormatter'
import { LkPassport, LkPassportStatus } from '@/typings/api/Passport'

const VIEW_PASSPORT: TableAction = {
  ...VIEW,
  tooltip: 'Посмотреть паспорт',
}


export const TABLE_ACTIONS = Object.freeze([
  VIEW_PASSPORT,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'id',
    value: 'id',
    sortable: false,
    width: '70px',
  },
  {
    text: 'Логин ОО',
    value: 'school_code',
    sortable: false,
    width: '100px',
  },
  {
    text: 'Краткое наименование ОО',
    value: 'school_name',
    sortable: false,
  },
  {
    text: 'Статус',
    value: 'status',
    sortable: false,
    width: '100px',
    field: (value: LkPassport['status']) => {
      switch (value) {
        case LkPassportStatus.NOT_STARTED:
          return 'Не приступал'
        case LkPassportStatus.IN_PROGRESS:
          return 'В работе'
        case LkPassportStatus.SUBMITTED:
          return 'Сдано'
        default:
          return ''
      }
    },
  },
  {
    text: 'Дата обновления',
    value: 'updated_at',
    sortable: true,
    field: (value: LkPassport['updated_at']) => value && dateFormatter(value),
  },
  {
    text: '',
    value: 'actions',
    sortable: false,
  },
])
